import { DoterSpecies, FamilyParentProfile } from "@joonapp/web-shared"
import { create } from "zustand"

interface EditProfileModalStore {
  isOpen: boolean
  onOpen: (parentProfile: FamilyParentProfile) => void
  onClose: () => void

  profile: FamilyParentProfile | null
  avatar: DoterSpecies | null
  nickname: string
  firstName: string
  lastName: string

  setFirstName: (firstName: string) => void
  setLastName: (lastName: string) => void
  setNickname: (nickname: string) => void
  setAvatar: (avatar: DoterSpecies) => void
}

const initialState = {
  isOpen: false,
  avatar: null,
  nickname: "",
  firstName: "",
  lastName: "",
  profile: null,
}

const useEditProfileModalStore = create<EditProfileModalStore>((set) => ({
  ...initialState,
  onOpen: (parentProfile) =>
    set({
      isOpen: true,
      profile: parentProfile,
      avatar: parentProfile.user.parent_doter.type,
      nickname: parentProfile.nickname,
      firstName: parentProfile.user.name,
      lastName: parentProfile.user.last_name || "",
    }),
  onClose: () => set(initialState),

  setAvatar: (avatar) => set({ avatar }),
  setNickname: (nickname) => set({ nickname }),
  setFirstName: (firstName) => set({ firstName }),
  setLastName: (lastName) => set({ lastName }),
}))

export default useEditProfileModalStore
